import { useEffect } from 'react';
import { FieldShell } from './FieldShell';
import type { FieldComponentProps } from './types';

const nowISO = (): string => {
  const d = new Date();
  // YYYY-MM-DDTHH:mm (datetime-local format)
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(
    d.getMinutes(),
  )}`;
};

export const DateTimeField = ({ field, value, error, onChange }: FieldComponentProps) => {
  const c = field.constraints || {};
  const autoSelect = field.auto_select_date !== false;

  useEffect(() => {
    if (autoSelect && (value === '' || value === null || value === undefined)) {
      onChange(nowISO());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const todayDay = new Date().toISOString().slice(0, 10);
  const min = c.isFuture ? `${todayDay}T00:00` : undefined;
  const max = c.isPast ? `${todayDay}T23:59` : undefined;

  return (
    <FieldShell field={field} error={error}>
      <input
        id={field.title}
        type="datetime-local"
        className="form-input"
        value={typeof value === 'string' ? value : ''}
        min={min}
        max={max}
        onChange={(e) => onChange(e.target.value)}
      />
    </FieldShell>
  );
};
